<script setup lang="ts">
import AppSvgIcon from '../appSvgIcon/AppSvgIcon.vue';

export interface AppAlternativeFilterButtonProps {
  activeFiltersAmount: number;
  compact: boolean;
  text: string;
  showFiltersAriaLabel: string;
}

const props = defineProps<AppAlternativeFilterButtonProps>();

interface AppAlternativeFilterButtonEmits {
  (eventName: 'click'): void;
}

const emit = defineEmits<AppAlternativeFilterButtonEmits>();
</script>

<template>
  <button
    class="app-alternative-filter-button"
    :aria-label="props.showFiltersAriaLabel"
    @click="emit('click')"
  >
    <div v-if="props.activeFiltersAmount > 0" class="selected-filters-wrapper">
      <div class="circle" />
      <span class="selected-filters">
        {{ props.activeFiltersAmount }}
      </span>
    </div>
    <AppSvgIcon name="tune" size="18" />
    <div v-if="!props.compact && props.activeFiltersAmount === 0" class="text">
      {{ text }}
    </div>
  </button>
</template>

<style scoped lang="scss">
@import '../../styles/media';
@import '../../styles/_fonts.scss';

.app-alternative-filter-button {
  background-color: var(--color-white);
  color: var(--color-neutral-70);
  border: 1px solid var(--color-neutral-70);
  border-radius: var(--border-radius-8);
  text-decoration: none;
  padding: 7px 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-4);
  @include on-hover {
    background-color: var(--color-neutral-10);
  }
  &:focus-visible {
    border: 1px solid transparent;
    outline: solid 2px var(--color-neutral-70);
  }
  .text {
    @include font-label-s-bold;
  }
  .selected-filters-wrapper {
    min-height: 20px;
    min-width: 20px;
    @include font-label-s-bold;
    color: var(--color-white);
    position: relative;
    .circle {
      position: absolute;
      top: 0;
      left: 0;
      background-color: var(--color-neutral-70);
      border-radius: var(--border-radius-30);
      height: 100%;
      aspect-ratio: 1/1;
    }
    .selected-filters {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  &:active {
    transform: matrix(0.95, 0, 0, 0.95, 0, 0);
  }
  transition-property: background-color, transform;
  transition-duration: var(--transition-time-medium);
  transition-timing-function: ease-out;
}
</style>
